import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const buttonVariants = cva(
    "tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:!text-sm tw:font-medium tw:transition-all tw:disabled:pointer-events-none tw:disabled:opacity-50 [&_svg]:tw:pointer-events-none [&_svg:not([class*='size-'])]:tw:size-4 tw:shrink-0 [&_svg]:tw:shrink-0 tw:outline-none tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:focus-visible:ring-[3px] tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive",
    {
        variants: {
            variant: {
                default: 'tw:bg-blue-500 tw:text-white tw:shadow-xs tw:hover:bg-blue-600',
                destructive:
                    'tw:bg-red-500 tw:text-white tw:shadow-xs tw:hover:bg-red-500/80 tw:focus-visible:ring-destructive/20 tw:dark:focus-visible:ring-destructive/40',
                destructiveSoft:
                    'tw:bg-[#BF244633] tw:border tw:border-red-300 tw:text-white tw:shadow-xs tw:hover:bg-red-500/80 tw:focus-visible:ring-destructive/20 tw:dark:focus-visible:ring-destructive/40',
                outline:
                    'tw:border tw:bg-background tw:shadow-xs tw:hover:bg-accent tw:hover:text-accent-foreground tw:dark:bg-background tw:dark:border-gray-300 !tw:border-red-300',
                secondary:
                    'tw:bg-secondary tw:border-1 tw:text-secondary-foreground tw:shadow-xs tw:hover:bg-secondary-hover tw:border-blue-500',
                ghost: 'tw:hover:bg-accent tw:hover:text-accent-foreground tw:dark:hover:bg-accent/50',
                link: 'tw:text-blue-300 tw:hover:text-blue-300/80 tw:underline-offset-4 tw:hover:underline tw:!px-1',
            },
            size: {
                default: 'tw:h-9 tw:px-8 tw:py-2 tw:has-[>svg]:px-6',
                sm: 'tw:h-8 tw:rounded-md tw:gap-1.5 tw:px-3 tw:has-[>svg]:px-2.5',
                lg: 'tw:h-10 tw:rounded-md tw:px-6 tw:has-[>svg]:px-4',
                icon: 'tw:size-9',
            },
            rounded: {
                none: '',
                xs: 'tw:!rounded-xs',
                sm: 'tw:!rounded-sm',
                md: 'tw:!rounded-md',
                lg: 'tw:!rounded-lg',
                xl: 'tw:!rounded-xl',
                full: 'tw:!rounded-full',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
            rounded: 'xs',
        },
    },
)

const Button = React.forwardRef(({ className, variant, size, rounded, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'

    return (
        <Comp
            ref={ref}
            data-slot="button"
            className={cn(buttonVariants({ variant, size, rounded, className }))}
            {...props}
        />
    )
})

export { Button, buttonVariants }
